// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../shared/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntr > th[data-v-26c1d1f2] {\n  width: 20%;\n}\ntr > th[data-v-26c1d1f2]:nth-child(1) {\n  width: 40%;\n}\ntr > th[data-v-26c1d1f2]:nth-child(2) {\n  width: 25%;\n}\ntr > td[data-v-26c1d1f2] {\n  width: 20%;\n}\ntr > td[data-v-26c1d1f2]:nth-child(1) {\n  width: 40%;\n  word-wrap: break-word;\n}\ntr > td[data-v-26c1d1f2]:nth-child(2) {\n  width: 25%;\n}\n", ""]);
// Exports
module.exports = exports;
